import classNames from '@sindresorhus/class-names';
import React, {PropsWithChildren} from 'react';

import styles from './BaseHeaderButton.module.scss';

type Props = PropsWithChildren<{
  href?: string;
  hoverVariant: 'blue' | 'light';
  highlightOnTopScroll?: boolean;
  withTextPaddings?: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  'data-testid'?: string;
  'aria-label'?: string;
  'aria-expanded'?: boolean;
}>;

export const BaseHeaderButton = ({
  href,
  hoverVariant,
  highlightOnTopScroll,
  withTextPaddings,
  className,
  onClick,
  children,
  ...rest
}: Props) => {
  const Component = href ? 'a' : 'button';

  return (
    <Component
      href={href}
      onClick={onClick}
      className={classNames(
        styles.root,
        hoverVariant === 'blue' ? styles.blueHover : styles.lightHover,
        highlightOnTopScroll && styles.topScrollHightlight,
        withTextPaddings && styles.withTextPaddings,
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  );
};
